import React, { useEffect, useState } from 'react'

import { ElementsComposition } from '../Certificat/CertificatReussite'
import { policePrete } from '../Certificat/mesure'
import { IMAGES_BILAN } from './imagesBilan'

/* ⛔ APERCU D'UNE PAGE DU BILAN, EN SVG (07/10/2026, v3, MAQUETTE).
   Dessine une page composee par modeleBilan.js avec le dessin du certificat
   (`ElementsComposition`) : ce que l'apprenant voit est ce qu'il telecharge.
   Le SVG garde les proportions de la page et prend la largeur de son
   conteneur. */

/* vrai quand Questrial est chargee : on ne mesure pas les textes avant */
export const usePolicePrete = () => {
  const [pret, setPret] = useState(false)
  useEffect(() => {
    let vivant = true
    policePrete().then(() => { if (vivant) setPret(true) })
    return () => { vivant = false }
  }, [])
  return pret
}

const ApercuBilan = ({ page, variante = 'claire', libelle, style }) => {
  if (!page) return null
  const { largeur, hauteur } = page.page
  return (
    <svg
      viewBox={`0 0 ${largeur} ${hauteur}`}
      width="100%"
      role="img"
      aria-label={libelle}
      data-apercu-bilan
      style={{ display: 'block', aspectRatio: `${largeur} / ${hauteur}`, border: '1px solid #E8E1D6', boxSizing: 'border-box', ...style }}
    >
      <ElementsComposition elements={page.elements} images={IMAGES_BILAN[variante] || IMAGES_BILAN.claire} />
    </svg>
  )
}

export default ApercuBilan
